import { withStyles, Container } from "@material-ui/core";
import React from "react";
import styles from "./styles";
import TitlePage from "../../TitlePage";
import Icon1 from "../../../assets/images/requirements.png";

const procedure = [
  {
    icon: Icon1,
    name: "Tiếp nhận",
    desc: "Tiếp nhận thông tin, yêu cầu của khách hàng.",
    number: 1
  },
  {
    icon: Icon1,
    name: "Trao đổi",
    desc:
      "Trao đổi thống nhất nội dung - định hướng phát triển sản phẩm và đặt cọc.",
    number: 2
  },
  {
    icon: Icon1,
    name: "Tiến hành",
    desc:
      "Tiến hành thực hiện giao diện layout - code - test và hoàn thiện sản phẩm.",
    number: 3
  },
  {
    icon: Icon1,
    name: "Bàn giao",
    desc:
      "Bàn giao sản phẩm ( chỉnh sửa nếu có ) thanh toán phần còn lại và bảo trì.",
    number: 4
  }
];

const progress = [
  { name: "Thiết kế", percent: "80%" },
  { name: "HTML5/CSS3/JS", percent: "90%" },
  { name: "JavaScript (React Native, ReactJS, VueJS)", percent: "85%" },
  { name: "PHP/ NodeJS", percent: "90%" }
];

function Progress(props) {
  const { classes } = props;

  const renderProcedure = () => {
    return procedure.map((item, index) => (
      <div key={index} className={classes.box}>
        <div className={classes.procedureImg}>
          <img src={item.icon} alt={item.name} />
        </div>
        <div className={classes.procedureName}>
          <h3>{item.name}</h3>
          <h5>{item.desc}</h5>
        </div>
        <h2>{item.number}</h2>
      </div>
    ));
  };

  const renderProgress = () => {
    return progress.map((item, index) => (
      <div key={index} className={classes.progressBox}>
        <div className={classes.progressName}>
          <h5>{item.name}</h5>
          <p>{item.percent}</p>
        </div>
        <div className={classes.progressBar}>
          <div className={classes.progressFull}></div>
          <div
            style={{ width: `${item.percent}` }}
            className={classes.progressCurrent}
          ></div>
        </div>
      </div>
    ));
  };

  return (
    <Container className={classes.container} maxWidth="xl">
      <div className={classes.left}>
        <h1>Kỹ năng của chúng tôi</h1>
        <h5>Những ngôn ngữ lập trình chúng tôi sử dụng </h5>
        <div className={classes.progressZone}>{renderProgress()}</div>
      </div>

      <div className={classes.right}>
        <TitlePage
          style={{ textAlign: "center", marginBottom: 30 }}
          name="Quy trình làm việc"
          desc="Tuân thủ quy trình tuần tự phát triển sản phẩm"
        />
        <div className={classes.procedureZone}>{renderProcedure()}</div>
      </div>
    </Container>
  );
}

export default withStyles(styles)(Progress);
